import FormField from "../../../shared/components/FormField";
import { OTP_TABS } from "../constants/authentication.constants";
import { useOtpAuthentication } from "../hooks/useOtpAuthentication";

/**
 * Two-step passwordless login: enter email (WhatsApp OTP is disabled
 * pending Twilio setup), then verify the code sent to it, with a
 * cooldown-gated resend action.
 */
export default function OtpVerificationForm({ onBack, onSuccess }) {
    const {
        STEP,
        step,
        tab,
        email,
        otp,
        identifier,
        fieldError,
        loading,
        error,
        seconds,
        canResend,
        setEmail,
        setOtp,
        switchTab,
        sendOtp,
        handleSubmit,
    } = useOtpAuthentication({ onSuccess });

    return (
        <form className="ogm-auth-form" onSubmit={handleSubmit} noValidate>
            {step === STEP.INPUT && (
                <div className="ogm-otp-tabs">
                    <button
                        type="button"
                        className={tab === OTP_TABS.EMAIL ? "active" : ""}
                        onClick={() => switchTab(OTP_TABS.EMAIL)}
                    >
                        📧 Email OTP
                    </button>
                    <button
                        type="button"
                        className="disabled"
                        disabled
                        title="WhatsApp OTP is coming soon"
                    >
                        💬 WhatsApp OTP (soon)
                    </button>
                </div>
            )}

            {step === STEP.INPUT && tab === OTP_TABS.EMAIL && (
                <FormField
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={fieldError}
                    required
                />
            )}

            {step === STEP.OTP && (
                <>
                    <p className="ogm-otp-sent-to">
                        OTP sent to <strong>{identifier}</strong>
                    </p>
                    <FormField
                        type="text"
                        inputMode="numeric"
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                        error={fieldError}
                        autoFocus
                        required
                    />
                </>
            )}

            {error && (
                <p className="ogm-auth-error" role="alert">
                    {error}
                </p>
            )}

            <button className="ogm-primary-btn" disabled={loading} type="submit">
                {loading ? "Please wait…" : step === STEP.INPUT ? "Send OTP" : "Verify OTP"}
            </button>

            {step === STEP.OTP && (
                <span
                    className={`ogm-resend-otp ${!canResend ? "disabled" : ""}`}
                    onClick={canResend ? sendOtp : undefined}
                    role="button"
                    tabIndex={canResend ? 0 : -1}
                    aria-disabled={!canResend}
                >
                    {canResend ? "Resend OTP" : `Resend OTP in ${seconds}s`}
                </span>
            )}

            {onBack && (
                <span className="ogm-back-link" onClick={onBack} role="button" tabIndex={0}>
                    ← Back to Login
                </span>
            )}
        </form>
    );
}
